export default "__VITE_ASSET__DyhOq78o__"